import { Link } from 'react-router-dom';
import type { Manifest } from '@/types/manifest';
import { ManifestStatusBadge } from './manifest-status-badge';
import { ProgressBar } from './progress-bar';
import { formatToEST } from '@/lib/utils/date-format';

interface ManifestCardProps {
  manifest: Manifest;
}

export function ManifestCard({ manifest }: ManifestCardProps) {
  const formattedDate = formatToEST(manifest.createdAt, false);

  return (
    <Link
      to={`/manifests/${manifest.id}`}
      className="block bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition-colors border border-gray-700 hover:border-gray-600"
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-semibold">{manifest.bargeName}</h3>
          <p className="text-sm text-gray-400">Created {formattedDate}</p>
        </div>
        <ManifestStatusBadge status={manifest.status} />
      </div>

      <ProgressBar current={manifest.scannedCount} total={manifest.expectedCount} />
    </Link>
  );
}
